import { useState, useEffect } from "react";

/**
 * useIsMobile — returns true when viewport width is at or below the breakpoint.
 * Used by App.js to conditionally render MobileShell vs Desktop components.
 * Default breakpoint: 860px (matches our design system).
 */
export default function useIsMobile(breakpoint = 860) {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth <= breakpoint : false
  );

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const handler = (e) => setIsMobile(e.matches);

    // Set initial value
    setIsMobile(mql.matches);

    // Listen for changes
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [breakpoint]);

  return isMobile;
}